import React from 'react';
import PropTypes from 'prop-types';

const Picture = ({ src, alt, className }) => {
  const urlFront = src ? src.substring(0, src.lastIndexOf('.')) : '';
  const ext = src ? src.slice(src.lastIndexOf('.'), src.length) : '';
  const smallUrl = src ? urlFront.concat('-small').concat(ext) : '';
  const mediumUrl = src ? urlFront.concat('-medium').concat(ext) : '';

  return src ? (
    <picture className={className}>
      <source srcSet={smallUrl.includes('fbcdn') ? src : smallUrl} media="(max-width: 350px)" />
      <source
        srcSet={mediumUrl.includes('fbcdn') ? src : mediumUrl}
        media="(min-width: 768px) and (max-width: 900px)"
      />
      <img className={className} src={src} alt={alt} srcSet={src} />
    </picture>
  ) : null;
};

Picture.propTypes = {
  src: PropTypes.string.isRequired,
  alt: PropTypes.string,
  className: PropTypes.string,
};

Picture.defaultProps = {
  alt: 'pic',
  className: '',
};

export default Picture;
